import {NameWithId} from "./Models";
import * as icons from "@fortawesome/free-solid-svg-icons";
import {IconDefinition} from "@fortawesome/free-regular-svg-icons";

export type GUID = string;
// constants.ts or some shared utility file
export const GUID_PATTERN = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
export const mediaQueries = {
    sm_Up: "(min-width: 576px)",
    md_Up: "(min-width: 768px)",
    lg_Up: "(min-width: 992px)",
    xl_Up: "(min-width: 1200px)",
    xxl_Up: "(min-width: 1400px)",

    // orientation queries
    isVertical:   "(orientation: portrait)",
    isHorizontal: "(orientation: landscape)",

    // device‐size shorthands
    // width breakpoints
    isMobile: "(max-width: 575.98px)",      // under 576px
    isTablet: "(min-width: 576px) and (max-width: 991.98px)", // 576 – 992
    isDesktop: "(min-width: 992px)",        // 992px+

    // optional capability hints
    isTouch: "(pointer: coarse)",           // coarse (finger) input
    noHover: "(hover: none)",               // devices that can’t hover
    
} as const;

export type ThemeColoursType =
    | "base"
    | "primary"
    | "secondary"
    | "tertiary"
    | "info"
    | "success"
    | "warning"
    | "error"
    | "dark"
    | "light"
    | "inverse"
    | null
    | undefined;

export type ButtonFillMode = null | 'solid' | 'outline' | 'flat' | 'link' | 'clear';

export type FlintValidationData = {
    validationMessage?: string | undefined,
    validateFunction?: (objectToValidate?: any) => Promise<void>,
    optionalObjectToValidate?: any
}

export namespace VivoPortal {
    export const ProductCode_EmeaLabs = [1];
    export const ProductCode_NaLabs = [2, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];
    export enum EnumOrderDateType {
        Created = 1,
        Requested = 2,
        Confirmed = 3,
        Completed = 4
    }

    export enum EnumMemberListFilterKeys {
        USER_FILTER_NewUsers = 1,
        USER_FILTER_Customers = 2,
        USER_FILTER_Employees = 3,
        USER_FILTER_Supervisors = 4,
        USER_FILTER_Admins = 5,
        USER_FILTER_Registered = 6,
        USER_FILTER_BrandOwners = 7,
        USER_FILTER_AllUsers = 8
    }

    export enum EnumCustomerSegments {
        Bronze = 1,
        Silver = 2,
        Gold = 4,
        Platinum = 8,
    }

    export enum ChartJobPercentageGrouping {
        Country = 1,
        Company = 2,
        ProjectLeader = 3
    }

    export enum ChartJobPercentageDataTypeFlag {
        Recipes = 1,
        ColourStandards = 2,
        DigiSwatchPrinted = 4,
        DigiSwatchPdf = 8,
        Total = 16,
        TimeInHours = 32
    }

    export enum EnumStatisticsChartType {
        JobStatistics = 1,
        DelayStatistics = 2,
        JobsPercentage = 3,
        SubstrateDe = 4,
        MobileAppStats = 5
    }

    export enum ChartSubstrateDeGrouping {
        Substrate = 1,
        De = 2
    }


    export enum EnumIconButtonDefaultType {
        Edit = 1,
        Preview = 2,
        Delete = 3,
        Download = 4,
        InternalUrl,
        ExternalUrl,
        Print,
        UnDelete,
        Save,
        Cancel,
        Select,
        Copy,
        Unlocked,
        Locked,
        Plus,
    }


    export enum EnumMemberGroupAliases {
        Admin = 1 << 0, // Admin (1)
        Customer = 1 << 1, // Customer (2)
        Employee = 1 << 2, // FG Employee (4)
        Supervisor = 1 << 3, // Laboratory Employee (8)
        User = 1 << 4, // Portal user (16)
        InactiveUser = 1 << 5, // Inactive user (32)
        Observer = 1 << 6, // Observer (64)
        SuperAdmin = 1 << 7 // Super Admin (128)
        // Translator = 1 << 8 // Translator (256)
    }

    export enum EnumSegment {
        PaperAndBoard = 1 << 0, // Paper & Board (1)
        Sheetfed = 1 << 1, // Sheetfed (2)
        Narrow_Web = 1 << 2, // Narrow Web (4)
        Flexible_Packaging = 1 << 3, // Flexible Packaging (8)
    }

    export enum EnumComponentType {
        Unknown = 0,
        Ink = 1,
        TC = 2,
        Additive = 4,
        Solvent = 8,
        Extender = 16
    }

    export enum EnumAttachmentType {
        CustomerForGccOrderAttachment = 1,
        GccForCustomerOrderAttachment = 2,
        CustomerForGccCommentAttachment = 4,
        GccForCustomerCommentAttachment = 8,
        GccForGcc = 16,
        TenderCompetitorsPrice = 32,
        TenderFlintGroupPrice = 64,
        TenderInkSeries = 128,
    }

    export enum EnumSegmentMnemonic {
        PB = 1 << 0, // Paper & Board (1)
        SF = 1 << 1, // Sheetfed (2)
        NW = 1 << 2, // Narrow Web (4)
        FP = 1 << 3, // Flexible Packaging (8)
    }

    export enum EnumOrderListFilter {
        MyOpen = 0,
        MyAll = 2,
        MyClosed = 1,
        AllOpen = 10,
        All = 11,
        Other = 3,
        Hierarchical = 20,
    }

    export enum EnumOrderStatus {
        Undefined = 0,
        Draft = 1,
        NewOrder = 2,
        Pending = 4,
        On_Work = 8,
        Done = 16,
        Rejected = 32,
        Complaint = 64,
        Archived = 128
    }

    export const EnumOrderStatus_AllOpen_NotDraft: EnumOrderStatus = EnumOrderStatus.NewOrder | EnumOrderStatus.On_Work | EnumOrderStatus.Pending | EnumOrderStatus.Complaint;
    export const EnumOrderStatus_DuringProcessing: EnumOrderStatus = EnumOrderStatus.On_Work | EnumOrderStatus.Pending | EnumOrderStatus.Complaint;
    export const EnumOrderStatus_AllOpen: EnumOrderStatus = EnumOrderStatus.Draft | EnumOrderStatus_AllOpen_NotDraft;
    export const EnumOrderStatus_Closed: EnumOrderStatus = EnumOrderStatus.Done | EnumOrderStatus.Archived | EnumOrderStatus.Rejected;

    // Mapping of descriptions to each enum value
    export const EnumOrderStatusDescriptions: Record<EnumOrderStatus, string> = {
        [EnumOrderStatus.Undefined]: "COMMON_UNDEFINED",
        [EnumOrderStatus.Draft]: "ORDER_STATUS_DRAFT",
        [EnumOrderStatus.NewOrder]: "ORDER_STATUS_NEW",
        [EnumOrderStatus.Pending]: "ORDER_STATUS_PENDING",
        [EnumOrderStatus.On_Work]: "ORDER_STATUS_ON_WORK",
        [EnumOrderStatus.Done]: "ORDER_STATUS_DONE",
        [EnumOrderStatus.Rejected]: "ORDER_STATUS_REJECTED",
        [EnumOrderStatus.Complaint]: "ORDER_STATUS_COMPLAINT",
        [EnumOrderStatus.Archived]: "ORDER_STATUS_ARCHIVED"
    };

    export const EnumOrderStatusIcons: Record<EnumOrderStatus, IconDefinition> = {
        [EnumOrderStatus.Undefined]: icons.faQuestion,
        [EnumOrderStatus.Draft]: icons.faStar,
        [EnumOrderStatus.NewOrder]: icons.faStar,
        [EnumOrderStatus.Pending]: icons.faHourglassHalf,
        [EnumOrderStatus.On_Work]: icons.faRefresh,
        [EnumOrderStatus.Done]: icons.faThumbsUp,
        [EnumOrderStatus.Rejected]: icons.faRectangleXmark,
        [EnumOrderStatus.Complaint]: icons.faThumbsDown,
        [EnumOrderStatus.Archived]: icons.faBoxArchive
    };

    export enum EnumNotificationElement {
        MainNotification = 1
    }

    export const GridPagingOptions: number[] = [
        10, 20, 50, 100, 200
    ]
    export const GridPagingDefaultValue: number = 50;

    export function CreateNameWithId(id: number, name: string, idString: string = ""): NameWithId {
        return {
            Id: id,
            Guid: "",
            ParentId: null,
            IdString: idString,
            Name: name,
            Deleted: false,
            Extension: undefined
        }
    }

    export function CreateDefaultNameWithId(name: string = "select an item", id: number = 0): NameWithId {
        return {
            Id: 0,
            Guid: "",
            ParentId: null,
            IdString: "",
            Name: name,
            Deleted: false,
            Extension: undefined
        }
    }

    export const languageList: NameWithId[] = [
        CreateNameWithId(1, 'English', 'en'),
        CreateNameWithId(2, 'Deutsch', 'de'),
        CreateNameWithId(3, 'Polski', 'pl'),
        CreateNameWithId(4, 'Français', 'fr'),
        CreateNameWithId(5, 'Español', 'es'),
        CreateNameWithId(6, 'Pусский', 'ru'),
        CreateNameWithId(7, 'Italiano', 'it'),
        CreateNameWithId(8, 'Türkçe', 'tr'),
        CreateNameWithId(9, 'Português', 'pt'),
    ];

    // export const divisionList : NameWithId[] = [
    //     CreateNameWithId(1, 'Paper & Board', 'PB'),
    //     CreateNameWithId(1, 'Sheetfed', 'SF'),
    //     CreateNameWithId(1, 'Narrow Web', 'NW'),
    //     CreateNameWithId(1, 'Flexible Packaging', 'FP'),
    // ];
    export namespace AppConstants {
        export namespace Filters {
        }
    }

    export enum EnumInkOrRecipe {
        /** COMMON_UNDEFINED */
        Undefined = -1,

        /** lblInkProduction */
        InkProduction = 1,

        /** lblRecipe */
        Recipe = 2
    }

    export enum EnumOrderFormType {
        /** Paper & Board */
        PBStandard = 1,

        /** Paper & Board (BO) */
        PBBrandOwner = 2,

        /** Sheetfed */
        SFDealer = 16,

        /** Narrow Web */
        NWStandard = 32,

        /** Flexible Packaging */
        FPStandard = 64,
    }

    export enum EnumOrderFlags {
        /** Indicates the order is a template. */
        Template = 1,

        /** Marks the order as important. */
        Important = 2,

        /** Flags the order with a question. */
        Question = 4,
    }

    export enum EnumCommentTypeFlag {
        /** Internal comment. */
        Internal = 1,

        /** Public comment. */
        Public = 2,

        /** Flint comment. */
        Flint = 4,
    }

    export enum EnumProjectSubStatuses {
        /** Default value. */
        Undefined = 128,

        /** Order checked and classified as NOT a project. */
        NotProject = 1,

        /** Admin marked the order as a project order (blue). */
        MarkedAsProject = 2,

        /** Coordinator has been assigned (orange). */
        CoordinatorAssigned = 4,

        /** Order approved for processing by the coordinator (green). */
        ApprovedForProcessing = 8,

        /** Processing done, awaiting coordinator's approval (orange). */
        AwaitingCoordinatorApproval = 16,

        /** Order marked as done, approved by the coordinator (no color). */
        FinallyApprovedByCoordinator = 32,

        /** Order not approved, returned for corrections (red). */
        ReturnedForProcessing = 64,
    }

    export enum EnumTenderModules {
        /** Competitors price */
        CompetitorsPrices = 1,

        /** Flint Group price */
        FlintGroupPrices = 2,

        /** Building blocks */
        BuildingBlocks = 4,

        /** Substrates */
        Substrates = 8,

        /** Master standard */
        MasterStandard = 16,

        /** dE Tolerance */
        ToleranceDe = 32,

        /** Ink series */
        InkSeries = 64,
    }

    export enum TenderSubstrateType {
        /** GCC substrate. */
        GccSubstrate = 1,

        /** Customer substrate. */
        CustomerSubstrate = 2,
    }

    export enum MasterStandardType {
        /** Digital Pantone. */
        DigitalPantone = 1,

        /** Paper Pantone. */
        PaperPantone = 2,

        /** CxF. */
        Cxf = 3,

        /** Wet Samples. */
        WetSamples = 4,

        /** L*a*b values. */
        LabValues = 5,

        /** Recipes. */
        Recipes = 6,
    }

    export enum EnumPermissionFlag {
        /** Permission to see. */
        CanSee = 1,

        /** Permission to add. */
        CanAdd = 2,

        /** Permission to edit. */
        CanEdit = 4,

        /** Permission to delete. */
        CanDelete = 8,
    }

    export enum DynamicListMainType {
        /** DE type. */
        DeType = 1,

        /** Spectrophotometer type. */
        SpectrophotometerType = 2,

        /** Filter type. */
        FilterType = 4,

        /** Light type. */
        LightType = 8,

        /** Angle type. */
        AngleType = 16,

        /** Application type. */
        ApplicationType = 32,

        /** Viscosity type. */
        ViscosityType = 64,

        /** Viscosity cup type. */
        ViscosityCupType = 128,

        /** Job type type. */
        JobTypeType = 256,

        /** Component series. */
        ComponentSerie = 512,

        /** Solvent type. */
        SolventType = 1024,

        /** Substrate type. */
        SubstrateType = 2048,

        /** OPV type. */
        Opv_Type = 4096,

        /** Opacity type. */
        OpacityType = 8192,

        /** Finish type. */
        FinishType = 16384,

        /** Resistance type. */
        ResistanceType = 32768,

        /** Interweb type. */
        InterwebType = 65536,

        /** Substrate2 type. */
        Substrate2Type = 131072,

        /** OPV type (type). */
        OpvType_Type = 262144,

        /** OPV sub-type (type). */
        OpvSubType_Type = 524288,

        /** Transfer type. */
        TransferType = 1048576,

        /** Measurement mode type. */
        MeasurementModeType = 2097152,

        /** Out of specification type. */
        OutOfSpecification = 4194304,

        /** No code reason type. */
        NoCodeReason = 8388608,

        /** Complaint status type. */
        ComplaintStatus = 16777216,

        /** Transfer micro type. */
        TransferMicoType = 33554432,

        /** Anilox plate bar type. */
        AniloxPlateBar = 67108864,

        /** Anilox position type. */
        AniloxPosition = 134217728,

        /** Finish2 type. */
        Finish2Type = 268435456,
    }

    export enum EnumOrderHierarchyStatus {
        /** Undefined status. */
        Undefined = 0,

        /** Root order. */
        RootOrder = 10,

        /** Correction order. */
        Correct = 20,

        /** Approved order. */
        Approve = 21,

        /** Print order. */
        Print = 30,

        /** Non-hierarchical order. */
        NotHierarchical = 99,
    }

    export enum ChartGroupByTime {
        Day = 1,
        Month = 2,
        Quarter = 3,
        Year = 4
    }

    export enum EnumOrderWithComplaintsSelection {
        StandardData = 1,
        ComplaintsData = 2
    }

    export enum EnumRedirectAfterSave {
        RedirectToPrintPage = 1,
        RedirectToOrderListPage = 2,
    }

    export enum EnumRequestTypes {
        Orders = 1,
        Complaints = 2,
        Activities = 4,
        Colors = 8,
        Progress = 16,
        Settings = 32,
        Delta = 64,
        Attachment = 128,
        Recipes = 256,
        Colors2 = 512,
        MobileDeviceRegistrations = 1024,
        InkSeries = 2048
    }
    export enum EnumRequiredDataQuantity {
        RecipePdf = 1,
        DigiSwatchElectronic = 2,
        ColourStandard = 3,
        DigiSwatchPrinted = 4,
        Other = 5
    }
    /** Product code type */
    export enum EnumProductCodeType {
        Undefined = 0,
        
        /** European, Middle Eastern and African region */
        EMEA = 1,

        /** United States region */
        US = 2
    }

}